import { BooleanAspect } from '@adornis/filter/aspect-schemas/BooleanAspect.js';
import { KpfFilter } from '@chancenwerk/shared/filter/KpfFilter.js';
import '@chancenwerk/client/design/components/cr-flex.js';
import { BehaviorSubject } from 'rxjs';

export const globalKpfFilter = new BehaviorSubject<KpfFilter>(
  new KpfFilter({
    aspects: [new BooleanAspect({ customID: 'active', value: true })],
  }),
);

globalKpfFilter.subscribe();
